// frontend/src/components/common/ConfirmDialog.js
//
// Reusable, declarative confirmation dialog built on MUI Dialog.
//
// This is the presentational component. It is driven either directly
// (pass `open`, `onConfirm`, `onCancel`, ...) or, more commonly, through the
// imperative `confirm()` helper exposed by NotificationContext, which manages
// the dialog state and returns a Promise<boolean>.
//
// Wave 1 note: this is additive infrastructure. Existing window.confirm call
// sites are migrated in a later wave; nothing here changes current behavior.

import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

export default function ConfirmDialog({
  open,
  title = 'Bist du sicher?',
  message = '',
  confirmText = 'Bestätigen',
  cancelText = 'Abbrechen',
  // MUI color for the confirm button. Use "error" for destructive actions.
  confirmColor = 'primary',
  onConfirm,
  onCancel,
}) {
  return (
    <Dialog
      open={!!open}
      onClose={onCancel}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      maxWidth="xs"
      fullWidth
    >
      {title && <DialogTitle id="confirm-dialog-title">{title}</DialogTitle>}
      <DialogContent>
        {typeof message === 'string' ? (
          <DialogContentText id="confirm-dialog-description">
            {message}
          </DialogContentText>
        ) : (
          message
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="inherit">
          {cancelText}
        </Button>
        <Button onClick={onConfirm} color={confirmColor} variant="contained" autoFocus>
          {confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
